<template lang="pug">
	page(v-loading="$apollo.loading").school
		company-access
</template>

<script>
import CompanyAccess from "./includes/CompanyAccess";

export default {
	components: {
		CompanyAccess
	}
};
</script>
